/* eslint-disable no-plusplus */
/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { TableCell, TableRow } from "@mui/material";
import React, { useMemo } from "react";
import moment from "moment";
// import Table from "../../../../components/common/new/Table/Table";
import { useSearchParams } from "react-router-dom";
import Table from "../Components/SubscriptionMisTable";
import tableStyle from "../../../../theme/styles/table";
import styles from "./SubscriptionTable.styles";
import Typography from "../../../../components/common/new/Typography/Typography";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const STATIC_COLUMNS = [
  //  {
  //     displayName: "S.NO",
  //     key: "s.no",
  //  },
  {
    displayName: "Area",
    key: "area",
  },
  {
    displayName: "Zone",
    key: "zone",
  },
  //  {
  //     displayName: "City",
  //     key: "city",
  //  },
  {
    displayName: "Region",
    key: "region",
  },
  {
    displayName: "Chapter",
    key: "chapter",
  },
  {
    displayName: "District",
    key: "district",
  },
  {
    displayName: "Block",
    key: "block",
  },
];

const generateMonthColumns = (startDate, months) => {
  const monthColumns = [];
  let currentDate = moment(startDate);

  for (let i = 0; i < months; i++) {
    const monthKey = currentDate.format("MMM").toLowerCase();
    monthColumns.push(
      {
        displayName: "Membership",
        key: `${monthKey}mem`,
      },
      {
        displayName: "Subscriptions",
        key: `${monthKey}sub`,
      },
      {
        displayName: "% Sub over Membership",
        key: `${monthKey}som`,
      }
    );
    currentDate = currentDate.add(1, "month");
  }

  return monthColumns;
};

const groupByStructureIdAndMonth = (
  data,
  { areaId, zoneId, regionId, chapterId, districtId }
) => {
  const grouped = {};

  data.forEach((item) => {
    const date = new Date(item.generatedAt);
    const monthYear = `${date.toLocaleString("default", { month: "short" })} ${
      date.getFullYear() % 100
    }`;

    // Store common properties
    if (!grouped[item.structureId]) {
      grouped[item.structureId] = {
        areaName: item.areaName,
        zoneName: item.zoneName,
        regionName: item.regionName,
        chapterName: item.chapterName,
        districtName: item.districtName,
        blockName: item.blockName,
      };

      if (areaId) {
        grouped[item.structureId].zoneName = item.structureName;
      }
      if (areaId && zoneId) {
        grouped[item.structureId].zoneName = item.zoneName;
        grouped[item.structureId].regionName = item.structureName;
      }
      if (areaId && zoneId && regionId) {
        grouped[item.structureId].zoneName = item.zoneName;
        grouped[item.structureId].regionName = item.regionName;
        grouped[item.structureId].chapterName = item.structureName;
      }
      if (areaId && zoneId && regionId && chapterId) {
        grouped[item.structureId].zoneName = item.zoneName;
        grouped[item.structureId].regionName = item.regionName;
        grouped[item.structureId].chapterName = item.chapterName;
        grouped[item.structureId].districtName = item.structureName;
      }
      if (areaId && zoneId && regionId && chapterId && districtId) {
        grouped[item.structureId].zoneName = item.zoneName;
        grouped[item.structureId].regionName = item.regionName;
        grouped[item.structureId].chapterName = item.chapterName;
        grouped[item.structureId].districtName = item.districtName;
        grouped[item.structureId].blockName = item.structureName;
      }
    }

    // assign the month-specific data:
    // Save the month-specific data
    if (!grouped[item.structureId][monthYear]) {
      grouped[item.structureId][monthYear] = {
        totalMemberCount: item.totalMemberCount,
        totalSubscriptionCount: item.totalSubscriptionCount,
        subscriptionPercentOverMember: item.subscriptionPercentOverMember,
      };
    }
  });

  return grouped;
};

const getUniqueMonths = (data) => {
  const uniqueMonths = new Set();

  data.forEach((item) => {
    const date = new Date(item.generatedAt);
    const monthYear = `${date.toLocaleString("default", { month: "short" })} ${
      date.getFullYear() % 100
    }`;
    uniqueMonths.add(monthYear);
  });

  // Convert months to Date then apply sorting
  const sortedMonths = Array.from(uniqueMonths).sort((a, b) => {
    const [monthA, yearA] = a.split(" ");
    const [monthB, yearB] = b.split(" ");

    const monthIndexA = new Date(`${monthA} 1, 20${yearA}`).getTime();
    const monthIndexB = new Date(`${monthB} 1, 20${yearB}`).getTime();

    return monthIndexA - monthIndexB;
  });

  return sortedMonths;
};

const getRows = ({
  searchData,
  areaId,
  zoneId,
  regionId,
  chapterId,
  districtId,
}) => {
  const months = getUniqueMonths(searchData);
  const groupedData = groupByStructureIdAndMonth(searchData, {
    areaId,
    zoneId,
    regionId,
    chapterId,
    districtId,
  });

  const totals = {
    totalMemberCount: {},
    totalSubscriptionCount: {},
    subscriptionPercentOverMember: {},
  };

  months.forEach((month) => {
    totals.totalMemberCount[month] = 0;
    totals.totalSubscriptionCount[month] = 0;
    totals.subscriptionPercentOverMember[month] = 0;
  });

  const rows = Object.keys(groupedData).map((structureId) => {
    const processedMonths = new Set();
    const structureData = groupedData[structureId];
    // const hierarchy = structureData[months[0]]?.hierarchy || "NA";
    return (
      <TableRow style={tableStyle.tableRow}>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {structureData?.areaName ?? "-"}
          </Typography>
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {structureData?.zoneName ?? "-"}
          </Typography>
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {structureData?.regionName ?? "-"}
          </Typography>
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {structureData?.chapterName ?? "-"}
          </Typography>
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {structureData?.districtName ?? "-"}
          </Typography>
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <Typography style={styles.typoghrphyStyle}>
            {structureData?.blockName ?? "-"}
          </Typography>
        </TableCell>
        {months.map((month) => {
          if (processedMonths.has(month)) {
            return null;
          }

          processedMonths.add(month);

          const monthData = structureData[month] || {};
          // Add to totals
          totals.totalMemberCount[month] += monthData.totalMemberCount || 0;
          totals.totalSubscriptionCount[month] +=
            monthData.totalSubscriptionCount || 0;
          totals.subscriptionPercentOverMember[month] +=
            monthData.subscriptionPercentOverMember || 0;

          return (
            <React.Fragment key={`${structureId}-${month}`}>
              <TableCell style={tabelCellWidth.medium}>
                <Typography style={styles.typoghrphyStyle}>
                  {monthData.totalMemberCount || "-"}
                </Typography>
              </TableCell>
              <TableCell style={tabelCellWidth.small}>
                <Typography style={styles.typoghrphyStyle}>
                  {monthData.totalSubscriptionCount || "-"}
                </Typography>
              </TableCell>
              <TableCell style={tabelCellWidth.small}>
                <Typography style={styles.typoghrphyStyle}>
                  {monthData.subscriptionPercentOverMember || "-"}
                </Typography>
              </TableCell>
            </React.Fragment>
          );
        })}
      </TableRow>
    );
  });
  const totalRow = (
    <TableRow style={tableStyle.tableRow} key="total-row">
      <TableCell style={tabelCellWidth.medium}>
        <Typography style={styles.typoghrphyStyle}>
          <strong>Total</strong>
        </Typography>
      </TableCell>
      <TableCell style={tabelCellWidth.medium} />
      <TableCell style={tabelCellWidth.medium} />
      <TableCell style={tabelCellWidth.medium} />
      <TableCell style={tabelCellWidth.medium} />
      <TableCell style={tabelCellWidth.medium} />
      {/* <TableCell style={tabelCellWidth.medium} />
      <TableCell style={tabelCellWidth.medium} /> */}
      {months.map((month) => (
        <React.Fragment key={`total-${month}`}>
          <TableCell style={tabelCellWidth.medium}>
            <Typography style={styles.typoghrphyStyle}>
              <strong>{totals.totalMemberCount[month]}</strong>
            </Typography>
          </TableCell>
          <TableCell style={tabelCellWidth.small}>
            <Typography style={styles.typoghrphyStyle}>
              <strong>{totals.totalSubscriptionCount[month]}</strong>
            </Typography>
          </TableCell>
          <TableCell style={tabelCellWidth.small}>
            <Typography style={styles.typoghrphyStyle}>
              <strong>{totals.subscriptionPercentOverMember[month]}</strong>
            </Typography>
          </TableCell>
        </React.Fragment>
      ))}
    </TableRow>
  );
  rows.push(totalRow);
  return rows;
};

function ReportTable({ searchData }) {
  const [searchParams] = useSearchParams();
  // const dateFrom = searchParams.get("startDate");
  //   const dateTo = searchParams.get("endDate");
  const areaId = searchParams.get("areaId");
  const zoneId = searchParams.get("zoneId");
  const regionId = searchParams.get("regionId");
  const chapterId = searchParams.get("chapterId");
  const districtId = searchParams.get("districtId");

  const { dateFrom, dateTo } = useMemo(() => {
    if (searchData && searchData.length > 0) {
      const dates = searchData.map((item) => moment(item.generatedAt));
      // Get the earliest and latest dates using moment.min/max
      const minDate = moment.min(dates);
      const maxDate = moment.max(dates);
      return {
        dateFrom: minDate.format("YYYY-MM-DD"),
        dateTo: maxDate.format("YYYY-MM-DD"),
      };
    }
    return { dateFrom: null, dateTo: null };
  }, [searchData]);

  // Logic to calculate number of Months
  const calculateNumberOfMonths = (startDate, endDate) => {
    const start = moment(startDate);
    const end = moment(endDate);

    if (!start.isValid() || !end.isValid()) {
      return 0;
    }

    return end.diff(start, "months") + 1; // Include both start and end months
  };

  const numberOfMonths = useMemo(
    () => calculateNumberOfMonths(dateFrom, dateTo),
    [dateFrom, dateTo]
  );

  const REPORT_TABLE_COL = useMemo(() => {
    const dynamicColumns = generateMonthColumns(dateFrom, numberOfMonths);
    return [...STATIC_COLUMNS, ...dynamicColumns];
  }, [dateFrom, numberOfMonths]);

  const rows = useMemo(() => {
    return getRows({
      searchData,
      areaId,
      zoneId,
      regionId,
      chapterId,
      districtId,
    });
  }, [searchData, areaId, zoneId, regionId, chapterId, districtId]);

  return (
    <div style={styles.container}>
      <Table
        scrollable
        columns={REPORT_TABLE_COL}
        rows={rows}
        tableHeadCellStyle={{
          ...styles.tableHeadCells,
          textAlign: "left",
        }}
        searchData={searchData}
      />
    </div>
  );
}

export default ReportTable;
